import { render, staticRenderFns } from "./view.vue?vue&type=template&id=f2767782&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=f2767782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2767782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2767782')) {
      api.createRecord('f2767782', component.options)
    } else {
      api.reload('f2767782', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=f2767782&scoped=true&", function () {
      api.rerender('f2767782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/securityCheckMgr/hiddenDangerRegister/view.vue"
export default component.exports